/**
 * Stack navigator for the new (Phase 1) onboarding wizard.
 * Wrapped in WizardProvider so every screen can read/write shared state.
 *
 * The root navigator is responsible for deciding whether to mount this
 * stack (based on user.onboardingVersion and onboardingStep).
 */
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { WizardProvider } from './WizardContext';
import { WizardProfileScreen } from './screens/WizardProfileScreen';
import { WizardHouseholdScreen } from './screens/WizardHouseholdScreen';
import { WizardRolesIntroScreen } from './screens/WizardRolesIntroScreen';
import { WizardProfessionalsScreen } from './screens/WizardProfessionalsScreen';
import { WizardDocumentsScreen } from './screens/WizardDocumentsScreen';
import { WizardSuccessorSoftAskScreen } from './screens/WizardSuccessorSoftAskScreen';
import { WizardPrioritiesRevealScreen } from './screens/WizardPrioritiesRevealScreen';

const Stack = createNativeStackNavigator();

export const WizardNavigator: React.FC = () => (
  <WizardProvider>
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
        animation: 'slide_from_right',
      }}
    >
      <Stack.Screen name="WizardProfile" component={WizardProfileScreen} />
      <Stack.Screen name="WizardHousehold" component={WizardHouseholdScreen} />
      <Stack.Screen name="WizardRolesIntro" component={WizardRolesIntroScreen} />
      <Stack.Screen name="WizardProfessionals" component={WizardProfessionalsScreen} />
      <Stack.Screen name="WizardDocuments" component={WizardDocumentsScreen} />
      <Stack.Screen name="WizardSuccessorSoftAsk" component={WizardSuccessorSoftAskScreen} />
      <Stack.Screen name="WizardPrioritiesReveal" component={WizardPrioritiesRevealScreen} />
    </Stack.Navigator>
  </WizardProvider>
);
